/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Receipt_IdInputs */

const en_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipt ID`)
};

const de_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingangs-ID`)
};

const fr_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant du reçu`)
};

const es_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID del justificante`)
};

const it_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID ricevuta`)
};

const nl_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontvangst-ID`)
};

const pl_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identyfikator potwierdzenia`)
};

const fi_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuitin tunnus`)
};

const da_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kvitterings-id`)
};

const sv_consumer_declaration_receipt_id = /** @type {(inputs: Consumer_Declaration_Receipt_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kvitto-id`)
};

/**
* | output |
* | --- |
* | "Receipt ID" |
*
* @param {Consumer_Declaration_Receipt_IdInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_receipt_id = /** @type {((inputs?: Consumer_Declaration_Receipt_IdInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Receipt_IdInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_receipt_id(inputs)
	if (locale === "fr") return fr_consumer_declaration_receipt_id(inputs)
	if (locale === "es") return es_consumer_declaration_receipt_id(inputs)
	if (locale === "it") return it_consumer_declaration_receipt_id(inputs)
	if (locale === "nl") return nl_consumer_declaration_receipt_id(inputs)
	if (locale === "pl") return pl_consumer_declaration_receipt_id(inputs)
	if (locale === "fi") return fi_consumer_declaration_receipt_id(inputs)
	if (locale === "da") return da_consumer_declaration_receipt_id(inputs)
	if (locale === "sv") return sv_consumer_declaration_receipt_id(inputs)
	return en_consumer_declaration_receipt_id(inputs)
});